<template>
    <b-container fluid class="p-3">
        <b-row>
            <b-col>
                <b-form inline>
                    <b-form-input
                        @input="refreshCompositions()"
                        :placeholder="$t('compositions.filter.id')"
                        id="idStartsWith"
                        v-model="idStartsWith">
                    </b-form-input>

                    <b-form-input
                        @input="refreshCompositions()"
                        :placeholder="$t('compositions.filter.decoupe')"
                        id="decoupeStartsWith"
                        v-model="decoupeStartsWith">
                    </b-form-input>

                    <v-select class="product" :reduce="name => name.psid" v-model="selectedProduct" @input="refreshCompositions()" :options="products" label="nom" placeholder="Toutes les matières">
                        <template v-slot:option="option">
                            {{ option.name[language] }}
                        </template>
                    </v-select>

                    <b-form-select
                        @change="refreshCompositions()"
                        id="thickness"
                        v-model="selectedThickness"
                        :options="thicknesses"
                        value-field="psid"
                        text-field="thickness">
                        <template v-slot:first>
                            <b-form-select-option :value="null"><t compositions.filter.allthicknesses /></b-form-select-option>
                        </template>
                    </b-form-select>

                    <b-button @click="refreshCompositions()">
                        <t common.refresh />
                    </b-button>

                </b-form>
                <template>
                    <div>
                        <b-form-file 
                            v-model="file" 
                            class="mt-3" 
                            accept=".dxf"
                            placeholder="Choisi ou glisse un fichier ici" 
                            browse-text = "Parcourir"
                            @input="importDXF(file)"></b-form-file>
                    </div>
                </template>
                <b-card-group deck class="compositions">
                    <b-card
                        v-for="composition in compositions"
                        v-bind:key="composition._id"
                    >
                        <b-media right-align no-body >
                            <b-media-aside vertical-align="center">
                                <svg v-if="composition.svg" xmlns="http://www.w3.org/2000/svg" :viewBox="composition.viewbox" v-html="composition.svgPart" class="thumbnail" />
                            </b-media-aside>

                            <b-media-body>
                                <b-badge>{{composition.dimensions}}</b-badge><br/>
                                {{composition.product ? composition.product.name[language] : 'No product'}}<br/>
                                {{composition.thickness ? composition.thickness.thickness : 'No thickness'}} mm<br/>
                                <span :title="composition.createdAtLabel">Créé {{composition.createdAtFromNow}}</span><br/>
                                <t compositions.customercode /> : {{composition.customerPsid}} <span v-if="composition.originalCustomerPsid != composition.customerPsid">( {{composition.originalCustomerPsid}} )</span><br/>
                                <t compositions.cuttingnumber/> : {{composition.decoupe}}
                            </b-media-body>
                        </b-media>

                        <template v-slot:header>
                            <a :href="protocol + '//' + editorUrl + '/load/' + composition._id + '/?token=' + jwt_token" target="_blank">
                                <b class="text-muted">{{composition._id.substring(0,6)}}</b>
                                <small class="text-muted">{{composition._id.substring(6)}}</small>
                            </a>
                            <div style="float: right">
                                <b-button-group>
                                    <b-button size="sm" variant="info" @click="changeCustomerPsid(composition)" :title="$t('compositions.changecustomercode')"><b-icon icon="file-person"></b-icon></b-button>
                                    <b-button size="sm" variant="danger" @click="archive(composition)" title="Archiver"><b-icon icon="trash"></b-icon></b-button>
                                    <b-button size="sm" variant="primary" title="Détails"><a :href="'/compositions/' + composition._id"><b-icon icon="info-circle"></b-icon></a></b-button>
                                </b-button-group>
                            </div>
                        </template>

                        <template v-slot:footer>
                            <small class="text-muted" :title="composition.updatedAtLabel"><t compositions.updatedat /> {{composition.updatedAtFromNow}}</small>
                        </template>
                    </b-card>
                </b-card-group>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>

import { BContainer, BRow, BCol, BCard, BCardGroup, BMedia, BMediaAside, BMediaBody, BBadge, BForm, BFormSelect, BFormSelectOption, BFormInput, BButton, BIcon, BIconTrash, BIconFilePerson, BIconInfoCircle, BButtonGroup, BFormFile } from 'bootstrap-vue';
import { models } from 'feathers-vuex';
import moment from 'moment';
import conf from '../../src/config/config';
import Log from 'loglevel';
import Api from '@/services/Api';
export default {
    components: {
        BContainer,
        BRow,
        BCol,
        BCard,
        BCardGroup,
        BMedia,
        BMediaAside,
        BMediaBody,
        BBadge,
        BForm,
        BFormSelect,
        BFormInput,
        BFormSelectOption,
        BButton,
        BIcon,
        BButtonGroup,
        BFormFile,
        // eslint-disable-next-line vue/no-unused-components
        BIconTrash, BIconFilePerson, BIconInfoCircle,
    },
    name: 'Compositions',
    data() {
        return {
            fields: [
                {
                    key: 'productPsid',
                    label: 'Produit',
                },
                {
                    key: 'thicknessPsid',
                    label: 'Epaisseur',
                    sortable: true
                },
                {
                    key: 'updatedAt',
                    label: 'Modification',
                    sortable: true
                },
                {
                    key: '_id',
                    label: 'ID',
                    sortable: true
                },
                {
                    key: 'svg',
                    label: 'Miniature',
                    sortable: false
                }
            ],
            compositions: [],
            selected: null,
            products: [],
            thicknesses: [],
            idStartsWith: '',
            decoupeStartsWith: '',
            selectedProduct: null,
            selectedThickness: null,
            editorUrl: null,
            file:null,
            language: 'fr'
        }
    },

    async mounted() {
        moment.defaultFormat = "DD/MM/YYYY HH:mm";
        moment.locale('fr');
        this.language = navigator.language.substr(0,2).toLowerCase();
        this.editorUrl = conf.editor_url;
        this.protocol = window.location.protocol;
        this.jwt_token = window.localStorage.getItem('feathers-jwt');
        await this.refreshProducts();
        await this.refreshThicknesses();
        await this.refreshCompositions();
    },

    methods: {
        async refreshProducts() {
            let blockSize = 20;
            let response = await models.api.Product.find({query: {$limit: blockSize}});
            this.products = response.data;
            let steps = response.total / blockSize;

            for (let i = 1; i < steps; i++) {
                response = await models.api.Product.find({query: {$limit: blockSize, $skip: i * blockSize}});
                this.products = this.products.concat(response.data);
            }
            this.products.sort((a, b) => a.name['fr'].localeCompare(b.name['fr']));
            this.products.forEach(e => e.nom = e.name[this.language]);
        },

        async refreshThicknesses() {
            let blockSize = 50;
            let response = await models.api.Thickness.find({query: {$limit: blockSize}});
            this.thicknesses = response.data;
            let steps = response.total / blockSize;

            for (let i = 1; i < steps; i++) {
                response = await models.api.Thickness.find({query: {$limit: blockSize, $skip: i * blockSize}});
                this.thicknesses = this.thicknesses.concat(response.data);
            }
            this.thicknesses.sort((a, b) => a.thickness - b.thickness);
        },

        async refreshCompositions() {
            let query = {
                $limit: 20,
                $sort: {
                    updatedAt: -1
                },
                //archived: false
            };
            if (this.idStartsWith != null && this.idStartsWith != "") query.compositionId = { $search: this.idStartsWith};
            if (this.decoupeStartsWith != null && this.decoupeStartsWith != "") query.decoupe = parseInt(this.decoupeStartsWith);
            if (this.selectedProduct != null) query.productPsid = this.selectedProduct;
            if (this.selectedThickness != null) query.thicknessPsid = this.selectedThickness;
            let response = await models.api.Composition.find({query});
            console.log(response);
            this.compositions = response.data;
            this.compositions.forEach(compo => this.afterLoad(compo));
        },

        afterLoad(composition) {
            composition.thickness = this.thicknesses.find(t => t.psid == composition.thicknessPsid);
            composition.product = this.products.find(p => p.psid == composition.productPsid);


            composition.viewbox = composition.viewboxdata == null
                ? "0 0 1000 1000"
                : (parseInt(composition.viewboxdata.x) - 10) + " " + (parseInt(composition.viewboxdata.y) - 10) + " " + (parseInt(composition.viewboxdata.width) + parseInt(composition.viewboxdata.x) + 20) + " " + (parseInt(composition.viewboxdata.height) + parseInt(composition.viewboxdata.y) + 20)

            composition.dimensions = composition.viewboxdata == null ? "" : parseInt(composition.viewboxdata.width) + " x " + parseInt(composition.viewboxdata.height);

            composition.updatedAtFromNow = composition.updatedAt == null ? "" : moment(composition.updatedAt).fromNow();
            composition.updatedAtLabel = composition.updatedAt == null ? "" : moment(composition.updatedAt).format('L LT');
            composition.createdAtFromNow = composition.createdAt == null ? "" : moment(composition.createdAt).fromNow();
            composition.createdAtLabel = composition.createdAt == null ? "" : moment(composition.createdAt).format('L LT');

            if (composition.svg) {
                composition.svgPart = Object.values(composition.svg).join('\n');
                composition.viewbox = (composition.viewboxdata.x - 10) + ' '
                    + (composition.viewboxdata.y - 10) + ' '
                    + (composition.viewboxdata.width + 20) + ' '
                    + (composition.viewboxdata.height + 20);
            }
        },

        async archive(composition) {

            if(confirm(this.$t('compositions.confirmarchive'))) {
                composition.archived = true;
                await composition.save();
                await this.refreshCompositions();
            }
        },

        async changeCustomerPsid(composition) {
            var customerPsid = prompt(this.$t('compositions.changecustomerprompt'), composition.originalCustomerPsid != composition.customerPsid ? composition.originalCustomerPsid : composition.customerPsid);
            if (customerPsid != null && customerPsid.length > 0) {
                composition.customerPsid = customerPsid;
                await composition.save();
                await this.refreshCompositions();
            }
        },

        async importDXF(file){
            let formData = new FormData();
            formData.append('files',file);
            try {
                const importDxfResponse = await Api().post(
                    'dxf-imports',
                    formData,
                    {
                        headers: {
                            'Authorization': `Bearer ${window.localStorage.getItem('feathers-jwt')}`,
                            'Accept': 'application/json',
                        },
                    }
                );
                window.location.href = window.location.protocol + '//' + this.editorUrl + '/load/' + importDxfResponse.data.compositionId + '?token=' + this.jwt_token;
            }
            catch (error) {
                if (error.response) {
                    Log.warn("Erreur API : " + error.message);
                } else if (error.request) {
                    Log.warn("Pas de réponse de l'API... : " + error.message);
                } else {
                    Log.warn("Erreur interne : " + error.message);
                }
                return;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    /* The sidebar menu */
    .compositions {
        .card {
            flex: 1 0 20%;
            margin: 0.5em;

            svg.thumbnail {
                width: 7em;
                height: 4em;
                path {
                    vector-effect: non-scaling-stroke;
                }
            }
        }
    }

    a{
        color: white;
        text-decoration: none;
    }

    .product{
        min-width: 20%;
        >>> .vs__dropdown-toggle{
            padding: 0.225rem 0.225rem;
        }
        >>> .vs__search{
            color: #495057;
        }
    }
</style>
